import { ButtonSize, ToggleButton, Tooltip, TooltipTrigger } from '@vizit/atoms';
import { Image01Icon } from '@vizit/icons';

interface CollectionAssetToolbarSparkToggleProps {
  /**
   * When true, generated (Spark) images are hidden
   */
  hideSparkImages: boolean;
  /**
   * Called when the user toggles the uploads-only filter; `hide` is true when only uploads
   * are shown (Spark images hidden)
   */
  onSparkVisibilityChange: (hide: boolean) => void;
}

/**
 * Uploads-only toggle for `CollectionAssetToolbar.Filters`.
 *
 * @param props - The component props
 */
function CollectionAssetToolbarSparkToggle({
  hideSparkImages,
  onSparkVisibilityChange,
}: CollectionAssetToolbarSparkToggleProps) {
  return (
    <TooltipTrigger delay={300}>
      <ToggleButton
        aria-label="Show uploads only"
        isSelected={hideSparkImages}
        onChange={onSparkVisibilityChange}
        size={ButtonSize.Md}
        iconStart={<Image01Icon size={20} aria-hidden />}
        data-testid="collection-asset-spark-toggle"
      />
      <Tooltip>Show uploads only</Tooltip>
    </TooltipTrigger>
  );
}

export { CollectionAssetToolbarSparkToggle };
export type { CollectionAssetToolbarSparkToggleProps };
